import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import axios from "../../../interceptor/axios-config";
import Swal from "sweetalert2";
import config from "../../../config";
import { useGrade } from "../../../context/GradeContext";

const EditStudentModal = ({ show, onHide, student, refresh }) => {

  const { grade } = useGrade();
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (student) {
      setFormData(student);
    }
  }, [student]);

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    if (type === "file") {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData(prev => ({
          ...prev,
          pass_photo: reader.result
        }));
      };
      if (file) reader.readAsDataURL(file);
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleUpdate = async () => {
    try {
        console.log(formData);

      const res = await axios.patch(
        `${config.apiBaseUrl}/students/update-student.php`,
        formData
      );

      if (res.data.success) {
        await Swal.fire("Success", "Student updated successfully", "success");
        refresh();
        onHide();
      } else {
        Swal.fire("Error", res.data.error, "error");
      }

    } catch (err) {
      Swal.fire("Error", "Server error", "error");
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Student</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {formData && (
          <Form>

            {/* PHOTO ON TOP */}
            <div className="text-center mb-4">

              {formData.pass_photo ? (
                <img
                  src={formData.pass_photo}
                  alt="Student"
                  style={{
                    width: 140,
                    height: 140,
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #ddd"
                  }}
                />
              ) : (
                <div className="text-muted">No Photo</div>
              )}

              <div className="mt-3">
                <Form.Control
                  type="file"
                  name="pass_photo"
                  onChange={handleChange}
                  style={{ maxWidth: 300, margin: "0 auto" }}
                />
              </div>
            </div>

            {/* 3 COLUMN LAYOUT */}
            <Row>

              {/* COLUMN 1 */}
              <Col md={4}>

                <Form.Group className="mb-3">
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    name="full_name"
                    value={formData.full_name || ""}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Roll No</Form.Label>
                  <Form.Control
                    name="roll_no"
                    value={formData.roll_no || ""}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Class</Form.Label>
                  <Form.Select
                    name="class_admitted"
                    value={formData.class_admitted || ""}
                    onChange={handleChange}
                  >
                    <option value="">Select Class</option>
                    {grade.map(g => (
                      <option key={g.value} value={g.value}>
                        {g.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

              </Col>

              {/* COLUMN 2 */}
              <Col md={4}>

                <Form.Group className="mb-3">
                  <Form.Label>Sex</Form.Label>
                  <Form.Select
                    name="sex"
                    value={formData.sex || ""}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option>Male</option>
                    <option>Female</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>DOB</Form.Label>
                  <Form.Control
                    type="date"
                    name="dob"
                    value={formData.dob?.slice(0,10) || ""}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>PEN</Form.Label>
                  <Form.Control
                    name="pen"
                    value={formData.pen || ""}
                    onChange={handleChange}
                  />
                </Form.Group>

              </Col>

              {/* COLUMN 3 */}
              <Col md={4}>

                <Form.Group className="mb-3">
                  <Form.Label>Guardian Name</Form.Label>
                  <Form.Control
                    name="guardian_name"
                    value={formData.guardian_name || ""}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Contact</Form.Label>
                  <Form.Control
                    name="contact_no"
                    value={formData.contact_no || ""}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    name="r_address"
                    value={formData.r_address || ""}
                    onChange={handleChange}
                  />
                </Form.Group>

              </Col>

            </Row>

          </Form>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>

        <Button variant="primary" onClick={handleUpdate}>
          Update Student
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditStudentModal;
